import { Navigate, Route, Routes } from 'react-router-dom';

import { DefaultLayout2 } from '@web/app/shared';

import { LogsPage } from '../pages';

export const LOGS_ROUTE_PATHS = {
    ROOT: '/',
} as const;

export const LogsRoutes = () => {
    return (
        <Routes>
            <Route element={<DefaultLayout2 />}>
                <Route path={LOGS_ROUTE_PATHS.ROOT} element={<LogsPage />} />
                <Route path="*" element={<Navigate to="/logs" replace />} />
            </Route>
        </Routes>
    );
};
